export const getData = async (): Promise<IState> => {
  const data = await fetch("https://torok-truck.firebaseio.com/.json");
  return await data.json();
};

export function isLoaded(state: any): state is IState {
  return state && !!state.prices;
}
